"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _button = require("@insided/deprecated-preact-components/design-system-components/button");

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _textArea = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-area"));

var _notifyAuthorOfModerationService = require("./notifyAuthorOfModerationService");

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotifyAuthorModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(NotifyAuthorModal, _PureComponent);

  var _super = _createSuper(NotifyAuthorModal);

  function NotifyAuthorModal() {
    var _this;

    (0, _classCallCheck2.default)(this, NotifyAuthorModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      selectedModerationReason: null,
      moderationDescription: '',
      errorMessage: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reasons", [{
      title: (0, _translations.t)('Control', 'dsareason.privacy_violation'),
      value: 'dsareason.privacy_violation'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.illegal_content'),
      value: 'dsareason.illegal_content'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.policy_violation'),
      value: 'dsareason.policy_violation'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.misinformation'),
      value: 'dsareason.misinformation'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.minor_protection'),
      value: 'dsareason.minor_protection'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.harmful_content'),
      value: 'dsareason.harmful_content'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.ip_infringement'),
      value: 'dsareason.ip_infringement'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.impersonation'),
      value: 'dsareason.impersonation'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.transparency_reporting'),
      value: 'dsareason.transparency_reporting'
    }, {
      title: (0, _translations.t)('Control', 'dsareason.consumer_information'),
      value: 'dsareason.consumer_information'
    }]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputChange", function (value) {
      if (NotifyAuthorModal.formattedDescription(value).length > 1000) {
        _this.setState({
          moderationDescription: value,
          errorMessage: 'Moderation description cannot exceed 1000 characters.'
        });

        return;
      }

      _this.setState({
        moderationDescription: value,
        errorMessage: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReasonSelect", function (value, title) {
      var descriptionKey = value.replace('reason', 'description');
      var description = (0, _translations.t)('Control', descriptionKey);

      _this.setState({
        selectedModerationReason: title,
        moderationDescription: description || '',
        errorMessage: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyAuthor", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, onClose, onShowAlert, privateId, publicId, replyPrivateId, replyPublicId, contentType, title, authorId, topicCreatedAt, repliedAt, contentAfterChange, contentBeforeChange, _this$state, selectedModerationReason, moderationDescription;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onClose = _this$props.onClose, onShowAlert = _this$props.onShowAlert, privateId = _this$props.privateId, publicId = _this$props.publicId, replyPrivateId = _this$props.replyPrivateId, replyPublicId = _this$props.replyPublicId, contentType = _this$props.contentType, title = _this$props.title, authorId = _this$props.authorId, topicCreatedAt = _this$props.topicCreatedAt, repliedAt = _this$props.repliedAt, contentAfterChange = _this$props.contentAfterChange, contentBeforeChange = _this$props.contentBeforeChange;
              _this$state = _this.state, selectedModerationReason = _this$state.selectedModerationReason, moderationDescription = _this$state.moderationDescription;

              if (!(selectedModerationReason === null)) {
                _context.next = 5;
                break;
              }

              onShowAlert('error', 'Please select a reason for the moderation action before sending the notification.');
              return _context.abrupt("return");

            case 5:
              if (!(moderationDescription.length > 1000)) {
                _context.next = 8;
                break;
              }

              _this.setState({
                errorMessage: 'Moderation description cannot exceed 1000 characters.'
              });

              return _context.abrupt("return");

            case 8:
              _this.setState({
                isLoading: true
              });

              _context.prev = 9;
              _context.next = 12;
              return (0, _notifyAuthorOfModerationService.notifyAuthorOfModeration)({
                moderationReason: selectedModerationReason,
                moderationDescription: NotifyAuthorModal.formattedDescription(moderationDescription),
                privateId: privateId,
                publicId: publicId,
                replyPrivateId: replyPrivateId,
                replyPublicId: replyPublicId,
                contentType: contentType,
                title: title,
                authorId: authorId,
                createdAt: topicCreatedAt,
                repliedAt: repliedAt,
                contentAfterChange: contentAfterChange,
                contentBeforeChange: contentBeforeChange
              });

            case 12:
              onShowAlert('success', 'Author has been notified via Email.');
              onClose();
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);
              onShowAlert('error', 'Failed to notify author. Please try again.');

            case 19:
              _context.prev = 19;

              _this.setState({
                isLoading: false
              });

              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16, 19, 22]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(NotifyAuthorModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var onClose = this.props.onClose;
      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          selectedModerationReason = _this$state2.selectedModerationReason,
          moderationDescription = _this$state2.moderationDescription,
          errorMessage = _this$state2.errorMessage;
      return (0, _preact.h)(_preactPortal.default, {
        into: "body"
      }, (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Notify author of moderation action"
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("p", null, "Select reason for DSA-Required Moderation Action"), (0, _preact.h)(_DropdownControl.default, {
        closeOnDropdownClick: true,
        align: "adjust",
        trigger: (0, _preact.h)(_Button.default, {
          type: "button",
          className: "notify-author-reason-selector-dropdown",
          title: selectedModerationReason !== null && selectedModerationReason !== void 0 ? selectedModerationReason : 'Select a reason',
          endIcon: "chevronDown",
          size: "medium",
          "data-track-type": "click",
          "data-element-name": "Select the reason to notify author"
        }),
        items: this.reasons.map(function (reason) {
          return {
            title: reason.title,
            onClick: function onClick() {
              return _this2.onReasonSelect(reason.value, reason.title);
            }
          };
        })
      }), (0, _preact.h)(_inputUnit.default, {
        isControl: true,
        error: errorMessage
      }, (0, _preact.h)(_textArea.default, {
        onInputChange: this.onInputChange,
        value: moderationDescription,
        placeholder: "Removed a section containing personal phone numbers to comply with privacy regulations.",
        rows: 10,
        isControl: true,
        size: "fullWidth"
      }))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_button.ButtonGroup, null, (0, _preact.h)(_Button.default, {
        title: "Notify Author",
        variant: "primary",
        onClick: this.onNotifyAuthor,
        disabled: !selectedModerationReason || errorMessage !== null,
        isLoading: isLoading,
        "data-qa": "notify-author",
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: onClose,
        size: "medium"
      })))));
    }
  }]);
  return NotifyAuthorModal;
}(_preactCompat.PureComponent);

(0, _defineProperty2.default)(NotifyAuthorModal, "formattedDescription", function (description) {
  return description.split('\n').filter(function (line) {
    return line.trim() !== '';
  }).map(function (line) {
    return "".concat(line, "<br/><br/>");
  }).join('').replace(/(<br\/>\s*)+$/g, '');
});
var _default = NotifyAuthorModal;
exports.default = _default;